export { default } from './card-divider.component';
